/**
 * Mock data source for the user's stored files.
 * Swap this file (or branch on env) for a real HTTP client when the API
 * lands. Consumers go through `files.service.ts`.
 */

export interface FileRecord {
  id: string
  name: string
  type: 'folder' | 'video' | 'document' | 'image' | 'audio' | 'other'
  size: string
  sizeBytes: number
  uploadedAt: string
  parentId: string | null
}

export const FILES_TOTAL_BYTES = 53_687_091_200 // 50 GB

const SEED: FileRecord[] = [
  { id: 'f1', name: 'Recordings',          type: 'folder',   size: '—',      sizeBytes: 0,          uploadedAt: 'Apr 10, 2026', parentId: null },
  { id: 'f2', name: 'Presentations',       type: 'folder',   size: '—',      sizeBytes: 0,          uploadedAt: 'Apr 08, 2026', parentId: null },
  { id: 'f3', name: 'Q1 Review.mp4',       type: 'video',    size: '1.2 GB', sizeBytes: 1288490188, uploadedAt: 'Apr 14, 2026', parentId: null },
  { id: 'f4', name: 'Product Launch.mp4',  type: 'video',    size: '820 MB', sizeBytes: 859832320,  uploadedAt: 'Apr 12, 2026', parentId: null },
  { id: 'f5', name: 'Slides_Q2.pptx',      type: 'document', size: '4.2 MB', sizeBytes: 4404019,    uploadedAt: 'Apr 11, 2026', parentId: null },
  { id: 'f6', name: 'Report_April.pdf',    type: 'document', size: '1.8 MB', sizeBytes: 1887436,    uploadedAt: 'Apr 09, 2026', parentId: null },
  { id: 'f7', name: 'Team Photo.png',      type: 'image',    size: '3.4 MB', sizeBytes: 3565158,    uploadedAt: 'Apr 07, 2026', parentId: null },
  { id: 'f8', name: 'Webinar Audio.mp3',   type: 'audio',    size: '45 MB',  sizeBytes: 47185920,   uploadedAt: 'Apr 06, 2026', parentId: null },
  { id: 'f9', name: 'March_Meeting.mp4',   type: 'video',    size: '650 MB', sizeBytes: 681574400,  uploadedAt: 'Mar 30, 2026', parentId: 'f1' },
  { id: 'fa', name: 'Feb_Review.mp4',      type: 'video',    size: '510 MB', sizeBytes: 534773760,  uploadedAt: 'Mar 10, 2026', parentId: 'f1' },
  { id: 'fb', name: 'Deck_v1.pptx',        type: 'document', size: '6.1 MB', sizeBytes: 6396313,    uploadedAt: 'Apr 01, 2026', parentId: 'f2' },
  { id: 'fc', name: 'Deck_Final.pptx',     type: 'document', size: '7.3 MB', sizeBytes: 7654400,    uploadedAt: 'Apr 05, 2026', parentId: 'f2' },
]

export const filesRepo = {
  async list(): Promise<FileRecord[]> {
    return SEED.map((f) => ({ ...f }))
  },
  async usedBytes(): Promise<number> {
    return SEED.reduce((sum, f) => sum + f.sizeBytes, 0)
  },
}
